import { useMemo } from 'react';

import { formatISO, parse } from 'date-fns';
import { useClient } from 'urql';
import { fromPromise } from 'xstate';

import { type ForgotToScanInput, type ForgotToScanResponse } from '../../utils';
import {
  IdentifyAndClaimInStoreOrderDocument,
  type IdentifyAndClaimInStoreOrderMutation,
  type IdentifyAndClaimInStoreOrderMutationVariables,
} from './GraphQL/IdentifyAndClaimInStoreOrder.generated';

export const useForgotToScanSubmission = () => {
  const client = useClient();

  const submitForm = useMemo(
    () =>
      fromPromise<ForgotToScanResponse, ForgotToScanInput>(async (event) => {
        const mutation = client.mutation<
          IdentifyAndClaimInStoreOrderMutation,
          IdentifyAndClaimInStoreOrderMutationVariables
        >;

        const formattedDate = formatISO(parse(event.input.purchaseDate, 'MM/dd/yyyy', new Date()));

        const total = Number.parseFloat(event.input.orderTotal) || 0;
        const totalInCents = Math.round(total * 100);

        const input = {
          orderId: event.input.orderId,
          restaurantZip: event.input.zipCode,
          date: formattedDate,
          total: totalInCents,
        };

        const response = await mutation(
          IdentifyAndClaimInStoreOrderDocument,
          { input },
          { requestPolicy: 'network-only' },
        ).toPromise();

        const result = response.data?.identifyAndClaimInStoreOrder?.__typename;

        return { result };
      }),
    [client.mutation],
  );

  return {
    submitForm,
  };
};
